import { createWatchlist as i } from "../../reactive/watchlist/main.js";
import { createInterval as n } from "../interval/main.js";
import { struct as a } from "../../../utils/struct/main.js";
import { enumerable as r } from "../../../utils/struct/property.js";
const b = (() => {
  let e;
  const { cancelSubscriptions: c, requestNotification: o, subscribe: s, on: t } = i({
    // Use wrapper function instead of direct reference to `Date.now`,
    // otherwise, tests will fail since `Date.now` won't be mocked
    now: () => Date.now()
  });
  return t.resume = () => {
    e = n(o, 1e3, !1);
  }, t.idle = () => {
    e == null || e.cancel(), e = void 0;
  }, a({
    cancelSubscriptions: r(c),
    subscribe: r(s)
  });
})();
export {
  b as clock,
  b as default
};
